import {
    SET_FILTER_ENTITIES
} from './actions';
import { Filter } from './types';

export const setFilterEntities = (filters: Filter[]) => ({
    type: SET_FILTER_ENTITIES,
    filters
});